module.exports = __webpack_public_path__ + "img/gray-4.0b0ea8d9.svg";